export const CATEGORY_COLORS = {
  triggers: '#2461DD',
  integrations: '#059669',
  wallet: '#7C3AED',
  logic: '#D97706',
  wallettwo: '#0891B2',
};

export const categoryForNodeType = (nodeType) => {
  if (nodeType?.startsWith('trigger_')) return 'triggers';
  if (nodeType?.startsWith('action_')) return 'integrations';
  if (nodeType?.startsWith('wallettwo_')) return 'wallettwo';
  if (nodeType?.startsWith('wallet_')) return 'wallet';
  if (nodeType?.startsWith('logic_')) return 'logic';
  return 'triggers';
};
